
<sales-list-item
  :item="sale"
  as="a"
  split
  :alert="sale.alertPrice"
  @click.native.stop.prevent="openSale"
>
  <align small-gap>
    <icon-button
      v-if="sale.notes"
      icon="info"
      :tooltip="sale.notes"
    />

    <template v-if="isLadderCard">
      <icon-button
        v-if="isStaff && purgatory"
        icon="move_to_inbox"
        tooltip="Move to sales"
        @click.stop.prevent="$emit('moveToSales', sale)"
      />

      <icon-button
        v-if="isStaff && !purgatory"
        icon="inventory"
        tooltip="Move to purgatory"
        @click.stop.prevent="$emit('moveToPurgatory', sale)"
      />

      <icon-button
        v-if="isStaff && !purgatory"
        icon="newspaper"
        tooltip="Add to Headlines"
        @click.stop.prevent="$emit('addToHeadlines', sale)"
      />

      <icon-button
        v-if="isStaff && !purgatory"
        icon="search"
        tooltip="View in Sales History"
        @click.stop.prevent="$emit('viewSalesHistory', sale)"
      />

      <icon-button
        v-if="!purgatory && sale.platform === 'eBay'"
        icon="pageview"
        tooltip="View sale on Terapeak Research"
        @click.stop.prevent="$emit('viewTerapeak', sale)"
      />

      <icon-button
        v-if="isStaff"
        icon="delete_outline"
        tooltip="Delete sale"
        @click.stop.prevent="$emit('deleteSale', purgatory ? sale.itemId : sale.id)"
      />
    </template>
  </align>
</sales-list-item>
